@if (label()) {
  <label [for]="id()" class="block text-sm font-medium mb-1" style="color:var(--talos-ink)">{{ label() }}</label>
}
<textarea
  [id]="id()"
  class="w-full border rounded py-2.5 px-3 text-sm focus:outline-none bg-[var(--talos-bg)] transition-colors text-talos-ink"
  [class.border-talos-ink/18]="!invalid()"
  [style.border-color]="invalid() ? 'var(--talos-accent)' : null"
  [placeholder]="placeholder()"
  [rows]="rows()"
  [attr.maxlength]="maxLength()"
  [value]="value()"
  [disabled]="isDisabled()"
  [style.resize]="resize()"
  (input)="onInput($event)"
  (blur)="onBlur()"
></textarea>
@if (hint() && !invalid()) {
  <span class="block text-xs mt-1" style="color:rgb(var(--talos-ink-rgb) / 0.4)">{{ hint() }}</span>
}
@if (invalid() && errorMessage()) {
  <app-field-message type="error" [message]="errorMessage()" />
}
